if($('footer#footer').length){
    $('footer#footer').before($('footer#footer .heurekaRating'))

   
    
}
